'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uniqueOpenings = uniqueOpenings;
exports.containsWeekendOpenings = containsWeekendOpenings;

var _dateUtils = require('./dateUtils');

// Returns Openings with unique times.
function uniqueOpenings(openings) {
  var openingsByTime = openings.reduce(function (memo, opening) {
    var key = opening.time.valueOf();
    if (memo[key] == null) {
      // eslint-disable-next-line no-param-reassign
      memo[key] = opening;
    }
    return memo;
  }, {});
  return Object.keys(openingsByTime).map(function (key) {
    return openingsByTime[key];
  });
}

// Returns true if the list of Openings contains at least one Opening on
// the weekend.
function containsWeekendOpenings(openings) {
  return (0, _dateUtils.containsWeekendDate)(openings.map(function (opening) {
    return opening.time;
  }));
}